"use client";
import { useLockBodyScroll } from "@/src/hooks/useLockBodyScroll";
import useModal from "@/src/hooks/useModal";
import { useState } from "react";
import { Logo, BurgerButton, DesktopMenu, MobileMenu } from "./components";
import ContactUs from "@/src/components/ContactUs";
import AudienceModal from "@/src/components/AudienceModal/AudienceModal";
import { NavRoutes } from "@/src/enums/header-items";
import { useRouter } from "next/navigation";
import { getRouteFromCategory } from "@/src/utils";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<string>("");
  const router = useRouter();

  const {
    isOpen: isContactModalOpen,
    openPopup: openContactModal,
    closePopup: closeContactModal,
  } = useModal();

  const {
    isOpen: isAudienceModalOpen,
    openPopup: openAudienceModal,
    closePopup: closeAudienceModal,
  } = useModal();

  useLockBodyScroll(menuOpen);

  const toggleMenu = () => setMenuOpen((prev) => !prev);
  
  const handleNavItemClick = (category: string) => {
    if (category === NavRoutes.TRADESHOWS) {
      setSelectedCategory(category);
      openAudienceModal();
    } else {
      const route = getRouteFromCategory(category);
      router.push(route);
    }
  };

  return (
    <nav
      className="header-container"
    >
      <Logo />

      <div className="md:hidden">
        <BurgerButton isOpen={menuOpen} onClick={toggleMenu} />
      </div>

      <DesktopMenu
        openContactModal={openContactModal}
        onNavItemClick={handleNavItemClick}
      />

      <MobileMenu
        isOpen={menuOpen}
        toggleMenu={toggleMenu}
        openContactModal={openContactModal}
        onNavItemClick={handleNavItemClick}
      />

      <ContactUs isOpen={isContactModalOpen} onClose={closeContactModal} />

      <AudienceModal
        isOpen={isAudienceModalOpen}
        onClose={closeAudienceModal}
        selectedCategory={selectedCategory}
      />
    </nav>
  );
}
